export interface ResolutionReason {
  Action: string;
  ResolutionReasonCode: string;
  ResolutionReason: string;
}

export enum ActionEnum {
  CANCEL = "CANCEL",
  ONHOLD = "ON HOLD",
  COMPLETE = "COMPLETE",
  ASSIGN = "ASSIGN",
}
